import React from 'react';
import { Card, Statistic, Row, Col, Empty } from 'antd';
import { Link } from 'react-router-dom';
import paths from 'assets/routes/paths';

function BacklogTile({ data, loading }) {
  if (loading) return <Card title="Backlog de solicitudes" loading />;
  if (!data) {
    return (
      <Card title="Backlog de solicitudes">
        <Empty description="Sin datos" />
      </Card>
    );
  }

  return (
    <Card title="Backlog de solicitudes">
      <Row gutter={[8, 8]}>
        <Col span={8}>
          <Link to={paths.admin.mantenciones.root}>
            <Statistic
              title="Sin asignar"
              value={data.sin_asignar}
              valueStyle={{ color: '#8c8c8c', fontSize: '1.6rem' }}
            />
          </Link>
        </Col>
        <Col span={8}>
          <Link to={paths.admin.mantenciones.root}>
            <Statistic
              title="Asig. s/ejecutar"
              value={data.asignadas_sin_ejecutar}
              valueStyle={{ color: '#fa8c16', fontSize: '1.6rem' }}
            />
          </Link>
        </Col>
        <Col span={8}>
          <Link to={paths.admin.mantenciones.root}>
            <Statistic
              title="En curso +7d"
              value={data.en_curso_vencidas}
              valueStyle={{ color: '#f5222d', fontSize: '1.6rem' }}
            />
          </Link>
        </Col>
      </Row>
    </Card>
  );
}

export default BacklogTile;
